import { computed, type Env } from './env.type.ts';

export const env: Env = {
  ...computed,
  buildTarget: 'web',
  // 구독 게이트는 전 환경 defer(=false) — BE 시딩 완료 후 일괄 전환.
  subscriptionGateEnabled: true,
  // 결제 오픈 상태. false 로 두면 구독 퍼널 전체가 채널톡 문의 안내로 돌아간다.
  tossPaymentEnabled: true,
  // 표 엑셀 내보내기 — web 빌드 전용(native 는 CAN_EXPORT_XLSX 의 빌드 상수 항에서 이미 걸린다).
  canExportXlsx: true,
  // dev 배포 도메인.
  deployBaseUrl: 'https://test.app.heviton.com',
  api: {
    appLegacy: { baseUrl: 'https://app-dev.heviton.net' },
    v2: { baseUrl: 'https://heviton-advance.heviton.com:16446' },
    // web-legacy = /api/2.0 (v2 와 동일 BE host).
    webLegacy: { baseUrl: 'https://heviton-advance.heviton.com:16446' },
  },
  // 공개 테스트 키 — 인하우스 dev 에서도 빌링 테스트 가능(헤리트 테스트 키는 Toss 승인 전이라 빌링 불가).
  tossClientKey: 'test_ck_0RnYX2w532wP7AOagKyMVNeyqApQ',
  // web push — dev 프로젝트(heviton-app-user).
  firebase: {
    apiKey: 'AIzaSyCDlfFoe1O6Pu-0h53nujDlDR7FVt16hfM',
    authDomain: 'heviton-app-user.firebaseapp.com',
    projectId: 'heviton-app-user',
    storageBucket: 'heviton-app-user.firebasestorage.app',
    messagingSenderId: '985969867510',
    appId: '1:985969867510:web:83d24895643eb5f6de0ad7',
    measurementId: 'G-WYB8T73HEL',
    vapidKey:
      'BJ07rtdmLfPMh92tBOVzrAEwPvulSVzC9Q72T5OnoOKtZEIn6klGGwwrEsVuxlBi6rOB6Tk60ZWrCxvHR0qzwQc',
  },
};
